export default __webpack_public_path__ + "static/31_31-fe1476dfdea35be4412aeb3460a52584.png";